/**
 * Created by fworld on 2019/9/26.
 */

import request from '@/util/request'

export const drinkDeviceUnion = (params) => {
    return request({
        url: '/api/v1/delivery/drink/device/union',
        method: 'get',
        params
    })
}


export const drinkDeviceList = (params) => {
    return request({
        url: '/api/v1/delivery/drink/device/list',
        method: 'get',
        params
    })
}

export const drinkDeviceCreate = (data) => {
    return request({
        url: '/api/v1/delivery/drink/device/create',
        method: 'post',
        data
    })
}

export const drinkDeviceUpdate = (data) => {
    return request({
        url: '/api/v1/delivery/drink/device/update',
        method: 'post',
        data
    })
}



export const drinkDeviceSortCreate = (data) => {
    return request({
        url: '/api/v1/delivery/drink/device/sortCreate',
        method: 'post',
        data
    })
}


export const deviceSyncDrink = (params) => {
    return request({
        url: '/api/v1/delivery/device/syncDrink',
        method: 'get',
        params
    })
}

export const deviceFullPull = (params) => {
    return request({
        url: '/api/v1/delivery/device/fullPull',
        method: 'get',
        params
    })
}

export const deviceCtrlDrinkParamUpload = (data) => {
    return request({
        url: '/api/v1/delivery/device/ctrl/drinkParamUpload',
        method: 'post',
        data
    })
}



export const drinkDeviceAll = (params) => {
    return request({
        url: '/api/v1/delivery/drink/device/all',
        method: 'get',
        params
    })
}

export const deviceOnline = () => {
  return request({
    'url': '/api/v1/delivery/device/online',
    'method': 'GET',
  })
}

export const deviceDrink = (params) => {
  return request({
    'url': '/api/v1/delivery/device/drink',
    'method': 'GET',
    params
  })
}

export const drinkSyncUnion = (params) => {
  return request({
    'url': '/api/v1/delivery/drink/sync/union',
    'method': 'GET',
    params
  })
}

export const drinkSyncList = (params) => {
  return request({
    'url': '/api/v1/delivery/drink/sync/list',
    'method': 'GET',
    params
  })
}

export const drinkSyncParam = (params) => {
  return request({
    'url': '/api/v1/delivery/drink/sync/param',
    'method': 'GET',
    params
  })
}

export const drinkSyncDelete = (params) => {
  return request({
    'url': '/api/v1/delivery/drink/sync/delete',
    'method': 'GET',
    params
  })
}

export const drinkSyncDeviceUnion = (params) => {
  return request({
    url: '/api/v1/delivery/drink/sync/device/union',
    method: 'get',
    params
  })
}

export const drinkSyncDeviceList = (params) => {
  return request({
    url: '/api/v1/delivery/drink/sync/device/list',
    method: 'get',
    params
  })
}

export const drinkSyncProductUuid = (params) => {
  return request({
    url: '/api/v1/delivery/drink/sync/productUuid',
    method: 'get',
    params
  })
}

export const drinkSyncPushDevice = (data) => {
  return request({
    url: '/api/v1/delivery/drink/sync/pushDevice',
    method: 'post',
    data
  })
}


export const deviceDrinkMaterialFullPull = (params) => {
  return request({
      url: '/api/v1/delivery/device/materialPull',
      method: 'get',
      params
  })
}
